import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { AuthService } from '@shared/auth/auth.service';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { HousingUnitService } from 'app/services/housingunit-service';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';

/*
 * Edit Housing Unit
 */
@Component({
  selector: 'housingunit-edit',
  templateUrl: 'housingunit-edit.html',
  styleUrls: ['./housingunit-edit.scss']
})
export class HousingUnitEditComponent implements OnInit, AfterViewInit {
  @Input('housingUnitId')
  housingUnitId: number = 0;
  buttonText = "Add Housing Unit";
  loading: boolean = false;
  processing: boolean = false;
  address: string = "";
  housingUnit: IHousingUnit = {
    id: 0,
    wellHousingUnitKey: 0,
    householdHousingUnitKey: 0,
    householdHousingUnitStartDate: '',
    householdHousingUnitEndDate: '',    
    createDate: '',
    createdby: '',
    lastUpdatedBy: '',
    lastUpdated: '',
    modifiedBy: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    contactCellPhone: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    county: '',
    ownerFirstName: '',
    ownerLastName: '',
    ownerEmail: '',
    preferredContactMethod: '',
    latitude: 0,
    longitude: 0,
    comments: '',
    unitNumber: '',
    housingUnitDataSource: '',
    taxLotId: '',
    municipality: '',
    sourceComments: '',
    ohaComments: '',
    sourceID: '',
    map: '',
    taxLot: '',
    acres: '',
    unitType: '',
    acceptedServices: ''
  };

  housingUnitForm = new FormGroup({
    id: new FormControl(0),
    contactName: new FormControl('', Validators.required),
    contactEmail: new FormControl(''),
    contactPhone: new FormControl(''),
    preferredContactMethod: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    zip: new FormControl(''),
    mailingAddress: new FormControl(''),
    mailingCity: new FormControl(''),
    mailingState: new FormControl(''),
    mailingZip: new FormControl(''),
    county: new FormControl(''),
    latitude: new FormControl(0),
    longitude: new FormControl(0),
    comments: new FormControl(''),
    contactCellPhone: new FormControl(''),
    ownerFirstName: new FormControl(''),
    ownerLastName: new FormControl(''),
    ownerEmail: new FormControl(''),
    unitNumber: new FormControl(''),
    housingUnitDataSource: new FormControl(''),
    taxLotId: new FormControl(''),
    municipality: new FormControl(''),
    sourceComments: new FormControl(''),
    ohaComments: new FormControl(''),
    sourceID: new FormControl(''),
    map: new FormControl(''),
    taxLot: new FormControl(''),
    acres: new FormControl(''),
    unitType: new FormControl(''),
    acceptedServices: new FormControl('')
  });

  constructor(public oregonWellDataService: OregonWellDataService,
    public housingUnitService: HousingUnitService,
    private toastr: ToastrService, private route: ActivatedRoute,
    private sharedService: SharedService, private router: Router, public authService: AuthService) {

    //this.loading = true;
    let routeId = this.route.snapshot.paramMap.get("id");

    if (routeId != null && routeId != undefined && routeId.length > 0) {
      this.housingUnitId = Number(this.route.snapshot.paramMap.get("id"));
    }
    if (this.housingUnitId == null || this.housingUnitId < 0) {
      this.housingUnitId = 0;
    }
  }

  ngAfterViewInit(): void {
    // ngAfterViewInit
  }

  ngOnInit(): void {
    this.loadHousingUnit();
  }

  loadHousingUnit() {
    if (this.housingUnitId <= 0) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.buttonText = "Update Housing Unit";
    this.housingUnitService.getHousingUnitById(this.housingUnitId).subscribe(
      result => {
        this.housingUnit = result;
        this.setFormValues();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );

    
  }

  onSubmit() {
    // #region validation

    if (!this.housingUnitForm.valid) {
      this.toastr.error("Please fix form validation issues");
      return;
    }

    if (this.housingUnitForm.value.contactName == '') {
      this.toastr.error("Contact Name is required");
      return;
    }

    if (this.housingUnitForm.value.contactPhone == '' && this.housingUnitForm.value.contactEmail == '') {
      this.toastr.error("Contact Phone or Email is required");
      return;
    }

    // #endregion

    this.processing = true;
    this.getFormValues();

    if (this.housingUnitId > 0) {

      // save
      this.housingUnitService.saveHousingUnit(this.housingUnit).subscribe(
        result => {
          this.housingUnitId = result;
          this.loadHousingUnit();
          this.toastr.success("Housing Unit updated");
          this.processing = false;
        },
        error => {
          this.processing = false;
        }
      );
    }
    else {

      // add
      this.housingUnitService.saveHousingUnit(this.housingUnit).subscribe(
        result => {
          this.housingUnitId = result;
          this.toastr.success("Housing Unit updated");
          this.processing = false;
        },
        error => {
          this.processing = false;
        },
        () => {
          this.router.navigate(['housingunit/edit/' + this.housingUnitId]);
        }
      );
    }
  }

  delete() {
    this.sharedService.openConfirm("Are you sure you want to delete this Housing Unit?\n\n This action will remove all associations wells and households.\n");

    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
          // delete
          this.housingUnitService.deleteHousingUnit(this.housingUnitId).subscribe(
            result => {
              this.toastr.success("Housing Unit Deleted!");
              //route back to search
              this.router.navigate(['households/search']);
            },
            error => {
              this.toastr.error("Unable to delete Housing Unit.");
              this.processing = false;
            }
          );
        
      }
    });
  }

  getAddress(){
    var values = [];
    values.push(this.housingUnit.address1);
    values.push(this.housingUnit.address2);
    values.push(this.housingUnit.city);
    values.push(this.housingUnit.state);
    values.push(this.housingUnit.zip);
    return values.filter(x => x).join(', '); 
  }

  getFormValues() {
    this.housingUnit.id = this.housingUnitId;
    this.housingUnit.contactName = this.housingUnitForm.get('contactName').value;
    this.housingUnit.contactEmail = this.housingUnitForm.get('contactEmail').value;
    this.housingUnit.contactPhone = this.housingUnitForm.get('contactPhone').value;
    this.housingUnit.address1 = this.housingUnitForm.get('address1').value;
    this.housingUnit.address2 = this.housingUnitForm.get('address2').value;
    this.housingUnit.city = this.housingUnitForm.get('city').value;
    this.housingUnit.state = this.housingUnitForm.get('state').value;
    this.housingUnit.zip = this.housingUnitForm.get('zip').value;
    this.housingUnit.county = this.housingUnitForm.get('county').value; 
    this.housingUnit.mailingAddress = this.housingUnitForm.get('mailingAddress').value;
    this.housingUnit.mailingCity = this.housingUnitForm.get('mailingCity').value;
    this.housingUnit.mailingState = this.housingUnitForm.get('mailingState').value;
    this.housingUnit.mailingZip = this.housingUnitForm.get('mailingZip').value;
    this.housingUnit.preferredContactMethod = this.housingUnitForm.get('preferredContactMethod').value;
    this.housingUnit.latitude = this.housingUnitForm.get('latitude').value == 0 ? 0 : this.housingUnitForm.get('latitude').value;
    this.housingUnit.longitude = this.housingUnitForm.get('longitude').value == 0 ? 0 : this.housingUnitForm.get('longitude').value;
    this.housingUnit.comments = this.housingUnitForm.get('comments').value;
    this.housingUnit.contactCellPhone = this.housingUnitForm.get('contactCellPhone').value;
    this.housingUnit.ownerFirstName = this.housingUnitForm.get('ownerFirstName').value;
    this.housingUnit.ownerLastName = this.housingUnitForm.get('ownerLastName').value;
    this.housingUnit.ownerEmail = this.housingUnitForm.get('ownerEmail').value;
    this.housingUnit.unitNumber = this.housingUnitForm.get('unitNumber').value;
    this.housingUnit.housingUnitDataSource = this.housingUnitForm.get('housingUnitDataSource').value;
    this.housingUnit.taxLotId = this.housingUnitForm.get('taxLotId').value;
    this.housingUnit.municipality = this.housingUnitForm.get('municipality').value;
    this.housingUnit.sourceComments = this.housingUnitForm.get('sourceComments').value;
    this.housingUnit.ohaComments = this.housingUnitForm.get('ohaComments').value;
    this.housingUnit.sourceID = this.housingUnitForm.get('sourceID').value;
    this.housingUnit.map = this.housingUnitForm.get('map').value;
    this.housingUnit.taxLot = this.housingUnitForm.get('taxLot').value;
    this.housingUnit.acres = this.housingUnitForm.get('acres').value;
    this.housingUnit.unitType = this.housingUnitForm.get('unitType').value;
    this.housingUnit.acceptedServices = this.housingUnitForm.get('acceptedServices').value;
    this.housingUnit.modifiedBy = this.authService.username;
  }

  setFormValues() {
    this.address = this.getAddress();
    this.housingUnit.id = this.housingUnitId;
    this.housingUnitForm.get('contactName').setValue(this.housingUnit.contactName);
    this.housingUnitForm.get('contactEmail').setValue(this.housingUnit.contactEmail);
    this.housingUnitForm.get('contactPhone').setValue(this.housingUnit.contactPhone);
    this.housingUnitForm.get('address1').setValue(this.housingUnit.address1);
    this.housingUnitForm.get('address2').setValue(this.housingUnit.address2);
    this.housingUnitForm.get('city').setValue(this.housingUnit.city);
    this.housingUnitForm.get('state').setValue(this.housingUnit.state);
    this.housingUnitForm.get('zip').setValue(this.housingUnit.zip);
    this.housingUnitForm.get('county').setValue(this.housingUnit.county);
    this.housingUnitForm.get('mailingAddress').setValue(this.housingUnit.mailingAddress);
    this.housingUnitForm.get('mailingCity').setValue(this.housingUnit.mailingCity);
    this.housingUnitForm.get('mailingState').setValue(this.housingUnit.mailingState);
    this.housingUnitForm.get('mailingZip').setValue(this.housingUnit.mailingZip);
    this.housingUnitForm.get('preferredContactMethod').setValue(this.housingUnit.preferredContactMethod);
    this.housingUnitForm.get('latitude').setValue(this.housingUnit.latitude);
    this.housingUnitForm.get('longitude').setValue(this.housingUnit.longitude);
    this.housingUnitForm.get('comments').setValue(this.housingUnit.comments);
    this.housingUnitForm.get('contactCellPhone').setValue(this.housingUnit.contactCellPhone);
    this.housingUnitForm.get('ownerFirstName').setValue(this.housingUnit.ownerFirstName);
    this.housingUnitForm.get('ownerLastName').setValue(this.housingUnit.ownerLastName);
    this.housingUnitForm.get('ownerEmail').setValue(this.housingUnit.ownerEmail);
    this.housingUnitForm.get('unitNumber').setValue(this.housingUnit.unitNumber);
    this.housingUnitForm.get('housingUnitDataSource').setValue(this.housingUnit.housingUnitDataSource);
    this.housingUnitForm.get('taxLotId').setValue(this.housingUnit.taxLotId);
    this.housingUnitForm.get('municipality').setValue(this.housingUnit.municipality);
    this.housingUnitForm.get('sourceComments').setValue(this.housingUnit.sourceComments);
    this.housingUnitForm.get('ohaComments').setValue(this.housingUnit.ohaComments);
    this.housingUnitForm.get('sourceID').setValue(this.housingUnit.sourceID);
    this.housingUnitForm.get('map').setValue(this.housingUnit.map);
    this.housingUnitForm.get('taxLot').setValue(this.housingUnit.taxLot);
    this.housingUnitForm.get('acres').setValue(this.housingUnit.acres);
    this.housingUnitForm.get('unitType').setValue(this.housingUnit.unitType);
    this.housingUnitForm.get('acceptedServices').setValue(this.housingUnit.acceptedServices);
  }
}